import { Stack } from '@mantine/core';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { isStandalone } from '~portal/lib';
import { SsrComponent } from '~portal/lib/SsrComponent';

export const Route = createFileRoute('/_protected/insights/operator/$slug')({
  beforeLoad: () => {
    if (isStandalone) {
      throw redirect({ to: '/chat/$conversationId', params: { conversationId: 'new' } });
    }
  },
  component: OperatorDetailPage,
});

function OperatorDetailPage() {
  const { slug } = Route.useParams();
  return (
    <Stack gap="lg" p="lg">
      <SsrComponent path="/fragments/operators/:slug" params={{ slug }} label="Operator" />
    </Stack>
  );
}
